import electronicCity from "../../public/static/images/png/award-electronic-city.png";
import Aon from "../../public/static/images/png/award-AON.png";
import infoBank from "../../public/static/images/png/award-info-bank.png";
import jobStreet from "../../public/static/images/png/award-Jobstreet.png";
import koranSindo from "../../public/static/images/png/award-Koran-Sindo.png";
import telkom from "../../public/static/images/png/award-Telkom.png";
import wartaEkonomi from "../../public/static/images/png/award-Warta-ekonomi.png";

export const DataAwards = [
  {
    name: "Electronic City Awards 2019",
    image: electronicCity,
    items: "The Smartest Financing Partner"
  },
  {
    name: "Digital Brand Awards 2019",
    image: infoBank,
    items:
      "Peringkat III Best Overall Kategori Perusahaan Pembiayaan (Multifinance)"
  },
  {
    name: "Digital Brand Awards 2019",
    image: infoBank,
    items:
      "Peringkat I Kategori Perusahaan Pembiayaan (Multifinance) Aset Rp2,5 - 5 Triliun"
  },
  { name: "Best Branding Award 2016", image: jobStreet },
  {
    name: "Digital Brand Awards 2018",
    image: infoBank,
    items: "Kategori Perusahaan Pembiayaan"
  },
  {
    name: "Digital Brand Awards 2017",
    image: infoBank,
    items: "Peringkat Kedua, Kategori Perusahaan Pembiayaan"
  },
  {
    name: "Electronic City Awards 2017",
    image: electronicCity,
    items: "The Smartest Financing Partner"
  },
  {
    name: "2017 AON Best Employers Program",
    image: Aon,
    items: "AON Best Employers Program in the Asia-Pacific Region"
  },
  {
    name: "2017 AON Best Employers Program",
    image: Aon,
    items:
      "Regional AON Best Employer Program: Best Employer di India, Indonesia, Tiongkok dan Filipina"
  },
  {
    name: "Best Employer Award 2017",
    image: telkom,
    items: "Kategori: Institusi Keuangan"
  },
  {
    name: "Indonesia Digital Innovation Award 2017",
    image: wartaEkonomi,
    items:
      "Kategori: Perusahaan Pembiayaan dengan Aset Rp100 Miliar – 500 Miliar"
  },
  {
    name: "Indonesia Corporate PR Award (IPRA) 2017",
    image: wartaEkonomi,
    items: "The Best People Choice in Financing Industry"
  },
  {
    name: "Indonesia Best Foreign CEO 2017",
    image: wartaEkonomi,
    items: "Top 2 Foreign CEO (Kategori: Perusahaan Pembiayaan)"
  },
  {
    name: "Indonesia Multifinance Consumer Choice Award 2017",
    image: wartaEkonomi,
    items:
      "Multifinance Company with Very Good Performance (Kategori Kinerja Keuangan Aset Rp500 Miliar – Rp1 Triliun)"
  },
  {
    name: "Indonesia Multifinance Consumer Choice Award 2017",
    image: wartaEkonomi,
    items:
      "Top 5 Best Consumer Choice Multifinance Company (Kategori Pembiayaan Elektronik)"
  },
  {
    name: "Apresiasi Inovasi: Kategori Pelayanan & Pemasaran",
    image: koranSindo,
    items: "Penghargaan untuk aplikasi My Home Credit"
  }
];
